<template>
  <div class="globalLoad" :style="{'background-color':loadConfig.BgColor?loadConfig.BgColor:''}" v-if="loadConfig.status">
    <div class="globalLoad-wrapper">
      <div class="globalLoad-content">
          <img :src="getImgs('loading1.gif')">
        <div>{{$t('share.loading.'+loadConfig.title)}}</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .appInner .globalLoad {
    top: 0.76rem;
  }

  .iphoneX .globalLoad {
    top: 0.96rem;
  }

  .globalLoad {
    /* position: fixed;
    top: 0.56rem;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 103;
    opacity: 0.7;
    background-color: #fff */
    position: fixed;
    top: 0.56rem;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 103;
    /* background-color: #fff; */
  }

  .globalLoad-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    /* margin-left: -0.75rem; */
    margin-top: -1.5rem;
    transform:translate(-50%,-50%);
  }

  .globalLoad-content {
    text-align: center;
    font-size: 0.14rem;
  }

  .globalLoad-content>div {
    padding-top: 5px;
    color: #888
  }

  .globalLoad-content img {
    width: 1.5rem
    /* width: 48px; */
    /* height: 0.45rem; */
  }

</style>
<script>
  export default {
    data() {
      return {}
    },
    computed: {
      loadConfig() {
        return this.$store.getters.loadConfig
      }
    },
  }

</script>



// WEBPACK FOOTER //
// globalLoad.vue?9ed4e3a0